import { ClientsApi } from "@/Stub/V1";
import { BaseApiConfig } from "@/Service/Api/V1/BaseApiConfig";


export const ClientsApiClient = new ClientsApi(BaseApiConfig);